export const navLinks = [
  { id: "introduction", label: "Introduction" },
  { id: "story", label: "Story" },
  { id: "timeline", label: "Timeline" },
  { id: "quote", label: "Quote" },
];

export const heroContent = {
  titleLine1: "The Voice",
  titleLine2: "of",
  titleLine3: "Lebanon",
};
export const overviewContent = {
  title: "Overview",
  text: `Fairuz is one of the most iconic voices in the Arab world. Born in Lebanon, she became a symbol of timeless music and cultural identity. With her unique voice and poetic songs, Fairuz shaped generations and left a lasting influence on Arabic music. Her performances and collaborations with legendary composers created songs that continue to inspire millions across the world.`,
};
export const storyContent = {
  title: "The Story of Fairuz",
  paragraphs: [
    `Fairuz, born Nouhad Haddad in Lebanon in 1934, is one of the most iconic voices in the Arab world. From an early age, her remarkable talent for singing became clear, and music quickly became the center of her life.`,

    `In the 1950s, Fairuz began working with the Rahbani brothers, Assi and Mansour. Together they created songs that blended poetry, emotion, and traditional Arabic melodies, forming a unique musical style that captured the hearts of millions.`,

    `Over the decades, Fairuz’s voice became deeply connected with the cultural identity of Lebanon and the Arab world. Her songs were played in homes, on radios, and across generations, carrying messages of love, nostalgia, and hope.`,

    `Today, Fairuz remains a timeless symbol of Arabic music. Her voice continues to inspire listeners, reminding people of the beauty of music and the power of art to unite cultures.`,
  ],
};
export const timelineData = [
  { year: "1957", text: "First Radio Appearance" },
  { year: "1960", text: "Rise To Fame" },
  { year: "1970", text: "International Performances" },
  { year: "1990", text: "Culture Icon" },
];
export const quoteContent = {
  english: "I feel nostalgic, not sure for whom",
};
export const footerContent = {
  text: "A tribute to Fairuz — the voice that shaped generations. Digital collage project inspired by her timeless music.",
};